import { jsx as _jsx } from "react/jsx-runtime";
import { format } from 'date-fns';
import { styled } from 'styletron-react';
import { useIsInputFocused } from '../../../hooks/useIsInputFocused';
import { useTestIdAttribute, } from '../../../hooks/useTestIdAttribute';
import { InputBase } from '../InputBase/InputBase';
import { useInputStyle } from '../useInputStyles';
const StyledInput = styled('input', (p) => p.$style);
const INPUT_DATE_FORMAT = 'yyyy-MM-dd';
const formatDateToInputString = (value) => format(value, INPUT_DATE_FORMAT);
const getInputValue = (inputValue) => {
    if (inputValue === '')
        return '';
    if (!inputValue)
        return undefined;
    return formatDateToInputString(inputValue);
};
export const DateInput = ({ value: passedValue, defaultValue, label, caption, tooltip, tooltipTabIndex, error = false, updated = false, warning = false, isRequiredLabel = false, gapRight = false, testId, disabled, readOnly, onFocus, onBlur, onChange, onDateChange, ...inputProps }) => {
    const { isFocused, handleBlur, handleFocus } = useIsInputFocused({
        disabled,
        readOnly,
        onBlur,
        onFocus,
    });
    const inputStyle = useInputStyle({
        isFocused,
        readOnly,
        warning,
    });
    const testIdAttribute = useTestIdAttribute(testId);
    const handleChange = (e) => {
        const value = e.target.value;
        const newDate = !value ? '' : new Date(value);
        onChange?.(e);
        onDateChange?.(newDate);
    };
    const value = getInputValue(passedValue);
    const formattedDefaultValue = defaultValue
        ? formatDateToInputString(defaultValue)
        : undefined;
    return (_jsx(InputBase, { label: label, isRequiredLabel: isRequiredLabel, caption: caption, tooltip: tooltip, tooltipTabIndex: tooltipTabIndex, error: error, updated: updated, warning: warning, gapRight: gapRight, isFocused: false, children: _jsx(StyledInput, { $style: inputStyle, value: value, defaultValue: formattedDefaultValue, type: 'date', disabled: disabled, readOnly: readOnly, onFocus: handleFocus, onBlur: handleBlur, onChange: handleChange, ...testIdAttribute, ...inputProps }) }));
};
